import { LayoutsStore } from "src/slices/opie-forms-management/layouts/layouts-interface";

export const initialState: LayoutsStore = {
  isLoading: false,
  layouts: [],
  fetchMore: true,
};
